import classNames from "classnames";

export type ButtonProps = {
  children: React.ReactNode | React.ReactNode[];
  className?: any;
  theme?: "blue" | "red" | "green";
  type?: "submit" | "button" | "reset";
  onClick?: any;
};
function Button({
  children,
  className,
  theme,
  type = "button",
  onClick,
}: ButtonProps) {
  const buttonClassName = classNames(
    `shadow-md border  transition-all duration-500 relative rounded p-1 h-fit ${className}`,
    {
      "bg-[#4ab6c6] hover:bg-[#81cbd6] text-white border-[#4ab6c6]":
        theme === "blue",
      "bg-red-500 hover:bg-red-400 text-white border-red-600": theme === "red",
      "bg-green-500 hover:bg-green-400 text-white border-green-600":
        theme === "green",
      "bg-quaternary hover:bg-tertiary text-primary border-primary":
        theme === undefined,
    }
  );
  return (
    <div className={buttonClassName}>
      <button
        type={type}
        onClick={onClick}
        className="md:py-2 md:px-4 px-2 py-1 outline-none h-full w-full bg-transparent flex items-center justify-center"
      >
        {children}
      </button>
    </div>
  );
}

export default Button;
